import { setLocale } from 'yup';

export const FIELD_REQUIRED_MSG = 'Field is required';

export const config = () => {
  setLocale({
    mixed: {
      required: FIELD_REQUIRED_MSG,
    },
    string: {
      email: 'Invalid email address',
    },
  });
};
